// extracted by mini-css-extract-plugin
export default {"wrapper":"CopyableId_wrapper__iGiaL","value":"CopyableId_value__kyCyl","copyBtn":"CopyableId_copyBtn__yDOHC","copied":"CopyableId_copied__LFob+"};